import React, { useEffect, useState } from 'react';

import classes from "./sitesOnScheduleSearchBar.module.css";
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters.png'
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { ListBox } from 'primereact/listbox';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import DataManager from '../../hooks/DataManager';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';

const SitesOnScheduleSearchBar = (props) => {
  const { placeholder, onChange, value, handleFocus, handleBlur, setCategoryFilter, showFilterButton, reset, groups, selectedGroupFilter, setSelectedGroupFilter, selectedFilter, setSelectedFilter, sortBy, setSortBy, wHm, setWHm, woHm, setWoHm, excludeLocks, setExcludeLocks, excludePulse, setExcludePulse, portalSiteNameFilter, setPortalSiteNameFilter, includes, setIncludes, isSchedules} = props;
  console.log(groups)
  const [showFilters, setShowFilters] = useState(false);
  const [filterType, setFilterType] = useState("Ascending")
  const [selectedSorts, setSelectedSorts] = useState("")
  const dataManager = new DataManager();

  const [localSelectedGroupFilter, setLocalSelectedGroupFilter] = useState(selectedGroupFilter)
  const [localSelectedFilter, setLocalSelectedFilter] = useState(selectedFilter)
  const [localSortBy, setLocalSortBy] = useState(sortBy)
  const [localWHm, setLocalWHm] = useState(wHm)
  const [localWoHm, setLocalWoHm] = useState(woHm)
  const [localExcludePulse, setLocalExcludePulse] = useState(excludePulse)
  const [localExcludeLocks, setLocalExcludeLocks] = useState(excludeLocks)
  const [localPortalSiteNameFilter, setLocalPortalSiteNameFilter] = useState(portalSiteNameFilter)
  const [localIncludes, setLocalIncludes] = useState(includes)

  const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
          event.preventDefault();
      }
  };

  const handleClear = () => {
      onChange({ target: { value: '' } }); 
  };

  const handleShowFilters = () => {
    setShowFilters(prev => !prev);
  };

  const HandleResetFilters = () => {
    setSelectedFilter("")
    setSortBy("")
    setSelectedGroupFilter("")
    setWHm(false)
    setWoHm(false)
    setExcludeLocks(false)
    setExcludePulse(false)
    setPortalSiteNameFilter("")
    setIncludes(true)

    setLocalSelectedFilter("")
    setLocalSortBy([])
    setLocalSelectedGroupFilter([])
    setLocalWHm(false)
    setLocalWoHm(false)
    setLocalExcludePulse(false)
    setLocalExcludeLocks(false)
    setLocalPortalSiteNameFilter("")
    setLocalIncludes(true)

    setShowFilters(false)
  }


  useEffect(() => {
    if (reset > 0){
      HandleResetFilters()
    }
  }, [reset])

  const HandleApplyFilters = () => {
    setSelectedGroupFilter(localSelectedGroupFilter)
    setSelectedFilter(localSelectedFilter)
    setSortBy(localSortBy)
    setWHm(localWHm)
    setWoHm(localWoHm)
    setExcludeLocks(localExcludeLocks)
    setExcludePulse(localExcludePulse)
    setPortalSiteNameFilter(localPortalSiteNameFilter)
    setIncludes(localIncludes)

    setShowFilters(false)
  }
  

  const options = [
    "Single pin sites",
    "Multi pin sites",
    "Output 1 active",
    "Output 2 active", 
    "Output 3 active",
    "Output 4 active"
  ]

  const sorts = [
    "Online",
    "Offline", 
    "No portal site name"
  ]

  const HandleExcludeLocks = () => {
    setLocalExcludeLocks(!localExcludeLocks)
  }

  const HandleExcludePulse = () => {
    setLocalExcludePulse(!localExcludePulse)
  }

  const handleInputChange = (e) => {
    setLocalPortalSiteNameFilter(e.target.value);
    console.log('Current input:', e.target.value); // For debugging
  };

  const handleSetIncludes = () => {
    setLocalIncludes(true)
  }

  const handleSetExcludes = () => {
    setLocalIncludes(false)
  }

  const updateHolidayModeOptions = (type) => {
    switch (type) {
      case "all" : {
        setLocalWHm(false)
        setLocalWoHm(false)
        break;
      }
      case "wHm" : {
        setLocalWHm(true)
        setLocalWoHm(false)
        break;
      }
      case "woHm" : {
        setLocalWHm(false)
        setLocalWoHm(true)
      }
    }
  }

  return (
      <div className={classes.searchContainer}>
          <input
              className={classes.searchBar}
              placeholder={placeholder}
              value={value}
              onKeyPress={handleKeyPress}
              onChange={onChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              spellCheck={false}
          />

          <div className={classes.buttonGroup}>
              {value && (
                  <button className={classes.clearButton} onClick={handleClear} type="button">
                      ×
                  </button>
              )}
              { showFilterButton && <button className={classes.filterButton} onClick={handleShowFilters} type="button">
                  <img style={{ height: '30px', width: '30px' }} src={filters}/>
              </button>}
          </div>

          {showFilters && (
                <div className={classes.filterDropdown}>
                  
                    <div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Sort by:</label>
                        <MultiSelect
                            value={localSortBy}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}  
                            onChange={(e) => setLocalSortBy(e.value)}
                            options={options}
                            placeholder="Sorting method"
                            checkmark
                            highlightOnSelect
                            
                        />
                    </div>

                  { !isSchedules && <div className={classes.filterType}> 
                    <div className="flex gap-4 mt-3">
                        <RadioButton
                          style={{marginRight:"5px"}} 
                          inputId="asc"
                          name="sortOrder"
                          value="Ascending"
                          onChange={(e) => updateHolidayModeOptions("all")}
                          checked={(localWHm == false && localWoHm == false)}
                        />
                        <label style={{marginRight:"15px"}} htmlFor="asc" className="ml-2">All</label>

                        <RadioButton
                          style={{marginRight:"5px"}} 
                          inputId="desc"
                          name="sortOrder"
                          value="Descending"
                          onChange={(e) => updateHolidayModeOptions("wHm")}
                          checked={(localWHm == true && localWoHm == false)}
                        />
                        <label style={{marginRight:"15px"}} htmlFor="asc" className="ml-2">With temporary schedules</label>

                        <RadioButton
                          style={{marginRight:"5px"}} 
                          inputId="desc"
                          name="sortOrder"
                          value="Descending"
                          onChange={(e) => updateHolidayModeOptions("woHm")}
                          checked={(localWoHm == true)}
                        />
                        <label htmlFor="desc" className="ml-2">Without temporary schedules</label>
                    </div>
                  </div>}

                  <br></br>
                  <br></br>
                    <div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Filter:</label>
                        <MultiSelect 
                          value={localSelectedFilter} 
                          onChange={(e) => setLocalSelectedFilter(e.value)} 
                          options={sorts} 
                          placeholder="Select filters" 
                          className="w-full md:w-14rem"
                          style={{ width: '400px' }} />
                    </div>

                    <br></br>
                    <div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Group:</label>
                        <MultiSelect
                            value={localSelectedGroupFilter}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}  
                            onChange={(e) => setLocalSelectedGroupFilter(e.value)}
                            options={groups}
                            placeholder="Choose group"
                            filter                 
                            filterPlaceholder="Search groups..."
                        />
                    </div>

                    <div className={classes.filterType}>
                      <div className="flex flex-wrap justify-content-center gap-3">
                        {/* <div className="flex align-items-center">
                            <Checkbox  name="Exclude smart locks" value="Exclude smart locks" onChange={HandleExcludeLocks} checked={excludeLocks == true} />
                            <label style={{marginLeft:"8px"}} htmlFor="Exclude smart locks" className="ml-2">Exclude smart locks</label>
                        </div>
                        <br></br> */}
                        <div className="flex align-items-center">
                            <Checkbox  name="Exclude pulse" value="Exclude pulse" onChange={HandleExcludePulse} checked={localExcludePulse == true} />
                            <label style={{marginLeft:"8px"}} htmlFor="Exclude pulse" className="ml-2">Exclude sites with a pulse</label>
                        </div>
                      </div>
                    </div>

                    <br></br>

                    <div className={classes.filterType} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <label htmlFor="word" className="font-bold block mb-2">
                        Portal site name 
                      </label>

                      <div className="flex flex-wrap justify-content-center gap-3">
                        <div className="flex align-items-center">
                            <Checkbox  name="includes" value="Includes" onChange={handleSetIncludes} checked={localIncludes == true} />
                            <label style={{marginLeft:"8px"}} htmlFor="includes" className="ml-2">Includes the word</label>
                        </div>
                        <br></br>
                        <div className="flex align-items-center">
                            <Checkbox  name="excludes" value="Excludes" onChange={handleSetExcludes} checked={localIncludes == false} />
                            <label style={{marginLeft:"8px"}} htmlFor="excludes" className="ml-2">Excludes the word</label>
                        </div>
                      </div>

                      <InputText id="word" keyfilter="alphanum" value={localPortalSiteNameFilter} onChange={handleInputChange}/>

                    </div>

                    <div className={classes.buttonRow}>
                      <Button  type="button" style={{marginRight:"15px"}} label="Reset filters" onClick={HandleResetFilters} outlined severity='danger'/>
                      <Button  type="button" label="Apply" onClick={HandleApplyFilters}/>
                    </div>
                </div>
            )}
      </div>
  );
};

export default SitesOnScheduleSearchBar;